import { render, staticRenderFns } from "./NotificationSettingsStockwatchGrid.vue?vue&type=template&id=c6551e9a&"
import script from "./NotificationSettingsStockwatchGrid.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingsStockwatchGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports